import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const AppStoreColor = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();
  return (
    <Icon ref={ref} viewBox="0 0 16 16" {...props}>
      <path
        d="M12.1706 1H3.82765C2.26509 1 1 2.26509 1 3.82765V12.1724C1 13.7332 2.26509 14.9983 3.82765 14.9983H12.1724C13.7332 14.9983 15 13.7332 15 12.1706V3.82765C14.9983 2.26509 13.7332 1 12.1706 1Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <path
        d="M7.9405 4.2161L8.224 3.72616C8.399 3.41995 8.78925 3.31671 9.0955 3.49169C9.40175 3.66667 9.505 4.05687 9.33 4.36308L6.59825 9.09099H8.574C9.2145 9.09099 9.57325 9.8434 9.295 10.3648H3.5025C3.149 10.3648 2.8655 10.0814 2.8655 9.72791C2.8655 9.37445 3.149 9.09099 3.5025 9.09099H5.1265L7.2055 5.48819L6.55625 4.36133C6.38125 4.05512 6.4845 3.66842 6.79075 3.48994C7.097 3.31496 7.48375 3.4182 7.66225 3.72441L7.9405 4.2161ZM5.4835 11.021L4.871 12.0831C4.696 12.3893 4.30575 12.4926 3.9995 12.3176C3.69325 12.1426 3.59 11.7524 3.765 11.4462L4.22 10.6588C4.7345 10.4996 5.15275 10.622 5.4835 11.021ZM10.758 9.09449H12.4152C12.7687 9.09449 13.0522 9.37795 13.0522 9.73141C13.0522 10.0849 12.7687 10.3683 12.4152 10.3683H11.4947L12.116 11.4462C12.291 11.7524 12.1877 12.1391 11.8815 12.3176C11.5752 12.4926 11.1885 12.3893 11.01 12.0831C9.9635 10.2686 9.17775 8.91076 8.65625 8.00612C8.1225 7.08574 8.504 6.16186 8.88025 5.84864C9.2985 6.56605 9.92325 7.64917 10.758 9.09449Z"
        fill="#fff"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id={`${iconPrefix}__a`} x1={8} x2={8} y1={1} y2={14.9983}>
          <stop stopColor="#18BFFB" />
          <stop offset={1} stopColor="#2072F3" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default AppStoreColor;
